module.exports = __webpack_public_path__ + "img/行业培训.6bb63c2b.png";